<template>
  <v-text-field
    class="search-field py-0"
    prepend-icon="search"
    hide-details
    :placeholder="placeholder"
    :value="value"
    @input="$emit('input', $event)"
    data-testid="search"
  />
</template>

<script>
export default {
  name: 'entity-search-field',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="sass">
.search-field
  min-width: 240px
</style>
